if (!window.vkBraFitGuideInitialized) {
  window.vkBraFitGuideInitialized = true;

  const cupByDifference = {
    1: 'A',
    2: 'B',
    3: 'C',
    4: 'D',
    5: 'DD',
    6: 'DDD',
    7: 'G',
    8: 'H',
    9: 'I',
    10: 'J',
  };

  const updateStartingSize = (calculator) => {
    const underbust = Number(calculator.querySelector('[data-vk-bra-fit-underbust]')?.value);
    const fullBust = Number(calculator.querySelector('[data-vk-bra-fit-full-bust]')?.value);
    const result = calculator.querySelector('[data-vk-bra-fit-result]');
    const resultText = calculator.querySelector('[data-vk-bra-fit-result-text]');
    const resultNote = calculator.querySelector('[data-vk-bra-fit-result-note]');

    if (!underbust || !fullBust || fullBust <= underbust || !result || !resultText || !resultNote) {
      if (result) result.hidden = true;
      return;
    }

    const band = Math.max(28, Math.min(48, Math.round(underbust / 2) * 2));
    const difference = fullBust - underbust;

    result.hidden = false;
    if (difference > 10) {
      resultText.textContent = 'Your starting cup is J+. Please contact a Fit Expert for help choosing the closest available style.';
      resultNote.textContent = 'Choose the closest available Band + Cup option on the product page.';
      return;
    }

    resultText.textContent = `Your starting size: ${band}${cupByDifference[difference]}`;
    resultNote.textContent = 'Choose the closest available Band + Cup option on the product page.';
  };

  document.addEventListener('change', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const calculator = target?.closest('[data-vk-bra-fit-calculator]');
    if (calculator) updateStartingSize(calculator);
  });
}
